import vuetifyToast from 'vuetify-toast'
import { router } from '@/helpers'
import { apiAxios, setApiToken } from '@/helpers/api'
const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}
const userStored = JSON.parse(localStorage.getItem('user'))
const rolesStored = JSON.parse(localStorage.getItem('roles'))

const initialState = () => {
  return {
    user: userStored || null,
    roles: rolesStored || [],
    profileModalActive: false,
    loading: false,
  }
}
const state = initialState()
const actions = {
  async login({ commit }, { email, password, register }) {
    try {
      commit('setLoading', true)
      const { data } = await apiAxios.post('/users/login', {
        email,
        password,
        register,
      })
      commit('setLogin', data.data)
      notify(data.message)
      router.push('/')
      // dispatch('permissions/setInitUserPermissions', null, { root: true })
    } catch (error) {
      commit('setLogout')
    } finally {
      commit('setLoading', false)
    }
  },
  async lostPassword({ commit }, { email, url }) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post('/users/reset', {
        email,
        url,
      })
      .finally(() => commit('setLoading', false))

    notify(data.message)
    router.push({ name: 'login' })
  },
  async logout({ commit, state }) {
    let email = state.user.email
    const { data } = await apiAxios
      .post('/users/logout', {
        email,
      })
      .finally(() => {
        commit('setLogout')
        router.push({ name: 'login' })
      })
    notify(data.message)
  },
  async refreshPermissions({ dispatch, commit }) {
    if (userStored) {
      // dispatch('permissions/setInitUserPermissions', null, { root: true })
      let user = await dispatch('users/fetchOne', userStored._id, {
        root: true,
      })
      commit('setLogin', { user })
    }
  },
  async toggleProfileModal({ state, commit, dispatch }) {
    commit('toggleProfileModal')

    if (state.profileModalActive) {
      await dispatch('users/fetchOne', state.user._id, { root: true })
    }
  },
}
const mutations = {
  setLoading(state, payload) {
    state.loading = payload
  },
  setLogin(state, payload) {
    let { user, token } = payload

    state.roles = user.roles
    localStorage.setItem('roles', JSON.stringify(user.roles))
    // delete user.roles

    state.user = user
    localStorage.setItem('user', JSON.stringify(user))

    if (token) {
      setApiToken(token)
      localStorage.setItem('userToken', token)
    }
  },
  setLogout(state) {
    state.user = null
    state.roles = []

    localStorage.removeItem('userToken')
    localStorage.removeItem('user')
    localStorage.removeItem('roles')
    localStorage.removeItem('permissions')
  },
  toggleProfileModal(state) {
    state.profileModalActive = !state.profileModalActive
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
